var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useContext, useEffect, useState } from 'react';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { DialogType } from '../../types/dialogs';
import { useInput } from '../common/use-input';
export function useAccountOverview() {
    var t = useI18n().t;
    var setServerLoading = useContext(LoadingContext).setServerLoading;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var _a = useContext(UserContext), user = _a.user, reconnectUser = _a.reconnectUser;
    var _b = useState(undefined), pendingBurnsCount = _b[0], setPendingBurnsCount = _b[1];
    var _c = useState(undefined), pendingTransfersCount = _c[0], setPendingTransfersCount = _c[1];
    var codeToRedeem = useInput('');
    useEffect(function () {
        function getPendingBurns() {
            return __awaiter(this, void 0, void 0, function () {
                var response, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            if (!(user === null || user === void 0 ? void 0 : user.mpcWalletAddress) && !(user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress))
                                return [2 /*return*/];
                            return [4 /*yield*/, gqlSdk.BlockchainPendingBurnFindMany()];
                        case 1:
                            response = _b.sent();
                            setPendingBurnsCount(response.blockchainPendingBurnFindMany.length);
                            return [3 /*break*/, 3];
                        case 2:
                            _a = _b.sent();
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        function getPendingTransfers() {
            return __awaiter(this, void 0, void 0, function () {
                var response, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            if (!(user === null || user === void 0 ? void 0 : user.mpcWalletAddress) && !(user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress))
                                return [2 /*return*/];
                            return [4 /*yield*/, gqlSdk.BlockchainPendingCtaTtokenTransferFindMany()];
                        case 1:
                            response = _b.sent();
                            setPendingTransfersCount(response.blockchainPendingCtaTtokenTransferFindMany.length);
                            return [3 /*break*/, 3];
                        case 2:
                            _a = _b.sent();
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        getPendingBurns();
        getPendingTransfers();
    }, [user]);
    function redeemCode() {
        return __awaiter(this, void 0, void 0, function () {
            var success, result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        success = false;
                        setServerLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, gqlSdk.RedeemCodesClaimReward({ input: { code: codeToRedeem.value } })];
                    case 2:
                        result = _a.sent();
                        success = result.redeemCodesClaimReward.success;
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1 instanceof Error) {
                            console.log(err_1.message);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        setServerLoading(false);
                        return [7 /*endfinally*/];
                    case 5:
                        codeToRedeem.setValue(success ? '' : codeToRedeem.value);
                        setDialogProps({
                            common: {
                                title: success ? t('common.success') : t('common.error'),
                                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: success ? t('redeem-code.success-message') : t('redeem-code.error-message'),
                            },
                        });
                        reconnectUser();
                        return [2 /*return*/];
                }
            });
        });
    }
    return { pendingBurnsCount: pendingBurnsCount, pendingTransfersCount: pendingTransfersCount, codeToRedeem: codeToRedeem, redeemCode: redeemCode };
}
